<template>
  <form @submit.prevent="handleSubmit(item)" novalidate>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
      <label for="_name" class="control-label">Nazwa</label>
      <input v-model="item.name" type="text" id="_name" class="form-control" />
      <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
    </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.amount) }">
            <label for="_amount" class="control-label">Cena</label>
            <b-input-group right="PLN">
                <b-form-input v-model="item.amount" type="number" id="_amount" ></b-form-input>
            </b-input-group>
            <span v-if="errors && errors.amount" class="help-block" id="_amount_helpBlock">{{ errors.amount }}</span>
        </div>

    <router-link :to="{ name: 'TransferTypeList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
    <my-button text="Zapisz" icon="tick" type="submit" />
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?672586f6